var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArticles = function SvgArticles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.42H5.684A1.895 1.895 0 0 0 3.79 6.317v2.526a1.895 1.895 0 0 0 1.895 1.895H12a1.895 1.895 0 0 0 1.895-1.895V6.316A1.895 1.895 0 0 0 12 4.42Zm.632 4.422a.632.632 0 0 1-.632.632H5.684a.632.632 0 0 1-.631-.632V6.316a.632.632 0 0 1 .631-.632H12a.632.632 0 0 1 .632.632v2.526ZM13.263 13.264H4.421a.631.631 0 1 0 0 1.263h8.842a.631.631 0 1 0 0-1.263ZM13.263 15.79H4.421a.632.632 0 0 0 0 1.263h8.842a.632.632 0 0 0 0-1.263ZM8.21 18.316H4.422a.632.632 0 0 0 0 1.264h3.79a.632.632 0 0 0 0-1.264Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.105 12H19.58a.631.631 0 1 0 0 1.263h2.526a.631.631 0 0 1 .632.632v6.316a1.895 1.895 0 0 1-1.895 1.895H19.58a1.895 1.895 0 0 1-1.895-1.895V2.527A1.894 1.894 0 0 0 15.79.632H1.896A1.895 1.895 0 0 0 0 2.527v18.947a1.895 1.895 0 0 0 1.895 1.895h18.947A3.158 3.158 0 0 0 24 20.21v-6.316A1.895 1.895 0 0 0 22.105 12ZM1.895 22.105a.631.631 0 0 1-.632-.631V2.527a.632.632 0 0 1 .632-.632H15.79a.632.632 0 0 1 .631.632V20.21c.002.195.023.39.063.58v.178c.033.129.075.256.126.379a2.724 2.724 0 0 0 .253.518l.101.164v.075H1.894Z",
    fill: "#fff"
  })));
};

export default SvgArticles;